import { SideImage } from '../../components/SideImage';
import { ExtrasContentPanel } from '../../composites/ExtrasContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { PackageExtrasTemplateProps } from './PackageExtrasTemplate.types';

export function PackageExtrasTemplate({
  imageUrl,
  imageAlt = '',
  ...panelProps
}: PackageExtrasTemplateProps) {
  return (
    <SplitLayout
      leftWidth="45%"
      contentMaxWidth="660px"
      height="var(--layout-viewport-height, 100vh)"
      left={<SideImage src={imageUrl ?? undefined} alt={imageAlt} sticky />}
      right={<ExtrasContentPanel {...panelProps} />}
    />
  );
}
